import { useState, useEffect, useContext } from "react";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Features } from "../components/features";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import { Testimonials } from "../components/testimonials";
import { Team } from "../components/Team";
import { News } from "../components/News";
import { Contact } from "../components/contact";
import { apiBaseUrl } from "../config/api";
import { useLocation } from "react-router";
import LoadingSpinner from "../shared/components/LoadingSpinner";
import BackDrop from "../shared/components/backDrop";
import axios from "axios";
import { AuthContext } from "../context/auth-context";
import "../App.css";

const LandPage = () => {
  const location = useLocation();
  const [landingPageData, setLandingPageData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const authContext = useContext(AuthContext);
  const isRtl = authContext.currentLanguage === "AR" ? true : false;
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (location.hash && landingPageData) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location, landingPageData]);
  const getData = async () => {
    setIsLoading(true);
    axios
      .get(`${apiBaseUrl}/site`)
      .then((res) => {
        setLandingPageData(res.data.landingPageData);
        console.log("the landing data is ", res.data.landingPageData);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("the err is err", err);
      });
  };

  return (
    <div>
      {isLoading && (
        <BackDrop>
          <LoadingSpinner />
        </BackDrop>
      )}
      <div>
        {landingPageData && (
          <>
            <Navigation home={true} isRtl={isRtl} />
            <Header data={landingPageData.Header} isRtl={isRtl} />
            <Features data={landingPageData.Features} isRtl={isRtl} />
            <About data={landingPageData.About} isRtl={isRtl} />
            <Services data={landingPageData.Services} isRtl={isRtl} />
            <Gallery data={landingPageData.Projects} isRtl={isRtl} />
            <News data={landingPageData.News} isRtl={isRtl} />
            {/* <Testimonials data={landingPageData.Testimonials} /> */}
            <Team data={landingPageData.Team} isRtl={isRtl} />
            <Contact data={landingPageData.Contact} isRtl={isRtl} />
          </>
        )}
      </div>
    </div>
  );
};

export default LandPage;
